module.exports = __webpack_public_path__ + "img/addShopCar.36c7c26b.svg";